import type React from 'react';
import { useNavigate } from 'react-router-dom';
import { SteamLoginButton } from '../components/SteamLoginButton';

export const LoginFailedPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <div className="mx-auto h-12 w-12 flex items-center justify-center rounded-full bg-red-100">
            <svg
              className="h-6 w-6 text-red-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </div>

          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">Login Failed</h2>

          <p className="mt-2 text-center text-sm text-gray-600">
            There was a problem signing you in with Steam
          </p>
        </div>

        <div className="mt-8 space-y-6">
          <div className="bg-white py-6 px-6 shadow rounded-lg">
            <div className="text-center">
              <h3 className="text-lg font-medium text-gray-900 mb-4">Authentication Error</h3>

              <div className="mb-6 text-sm text-gray-600 space-y-2">
                <p>The Steam authentication process encountered an error.</p>
                <p>This could be due to:</p>
                <ul className="text-left mt-2 space-y-1 text-xs">
                  <li>• Steam service temporarily unavailable</li>
                  <li>• Network connection issues</li>
                  <li>• Authentication was cancelled</li>
                  <li>• Server configuration problems</li>
                </ul>
              </div>

              <div className="space-y-4">
                <SteamLoginButton className="w-full" />

                <button
                  onClick={() => navigate('/')}
                  className="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                  Return to Home
                </button>
              </div>
            </div>
          </div>

          <div className="text-center text-xs text-gray-500">
            <p>If this problem persists, please contact your system administrator.</p>
          </div>
        </div>
      </div>
    </div>
  );
};
